module.exports = __webpack_public_path__ + "static/img/02.8091813.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/02.jpg
// module id = e+hj
// module chunks = 0